// userSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RentalType, VehicleType } from "../../types";

interface DashboardState {
  showSmSidebar: boolean;
  dashboardType: "lessee" | "lessor";
  lesseeRentals: RentalType[];
  lessorRentals: RentalType[];
  vehicles: VehicleType[];
}

const initialState: DashboardState = {
  showSmSidebar: false,
  dashboardType: "lessee",
  lesseeRentals: [],
  lessorRentals: [],
  vehicles: [],
};

const dashboardSlice = createSlice({
  name: "dashboardState",
  initialState,
  reducers: {
    setShowSmSidebar: (state, action: PayloadAction<boolean>) => {
      state.showSmSidebar = action.payload;
    },
    setDashboardType: (state, action: PayloadAction<"lessee" | "lessor">) => {
      state.dashboardType = action.payload;
    },
    setLesseeRentals: (state, action: PayloadAction<RentalType[]>) => {
      state.lesseeRentals = action.payload;
    },
    setLessorRentals: (state, action: PayloadAction<RentalType[]>) => {
      state.lessorRentals = action.payload;
    },
    setVehicles: (state, action: PayloadAction<VehicleType[]>) => {
      state.vehicles = action.payload;
    },
  },
});

export const {
  setShowSmSidebar,
  setDashboardType,
  setLesseeRentals,
  setLessorRentals,
  setVehicles,
} = dashboardSlice.actions;
export default dashboardSlice.reducer;
